var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuntPlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 40,
    height: 40,
    style: {},
    filter: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.4 17.875l4.712 4.715-1.884 1.885 1.887 1.887-1.885 1.885-3.3-3.3-3.772 3.772-1.885-1.885 3.772-3.773-3.3-3.299 1.885-1.885 1.885 1.884 1.884-1.885zM4 4l4.728 0.004 15.756 15.757 1.887-1.885 1.885 1.885-3.299 3.3 3.771 3.772-1.885 1.885-3.772-3.772-3.3 3.3-1.885-1.885 1.885-1.887-15.767-15.767-0.004-4.708zM23.276 4l4.724 0.004 0.003 4.697-5.404 5.403-4.715-4.713 5.392-5.391z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuntPlayers);
export default __webpack_public_path__ + "static/media/stunt_players.8f9e83c49fae44acf3fa9ebb86595403.svg";
export { ForwardRef as ReactComponent };